import React from "react";
import AppointmentDetailsPage from "./components/AppointmentDetailsPage";
// import AppointmentDetailsPage from "./AppointmentDetailsPage";

export default function ChatComponent(aptId) {
  return (
    <>
      <div>
        {/* <AppointmentDetailsPage /> */}
        <AppointmentDetailsPage aptId={aptId}/>
      </div>
    </>
  );
}
